import { parseInlineMarkdown } from "@/lib/markdown";

export function MarkdownText({ text, className }: { text: string; className?: string }) {
  const segments = parseInlineMarkdown(text);
  return (
    <p className={className}>
      {segments.map((segment, i) => {
        const key = i;
        if (segment.bold && segment.italic) {
          return (
            <strong key={key}>
              <em>{segment.text}</em>
            </strong>
          );
        }
        if (segment.bold) return <strong key={key}>{segment.text}</strong>;
        if (segment.italic) return <em key={key}>{segment.text}</em>;
        if (segment.code) return <code key={key}>{segment.text}</code>;
        return segment.text;
      })}
    </p>
  );
}
